import useWarehouseReceivingZone from "../../customHooks/useWarehouseReceivingZone";
import { Form } from "antd";
import { useEffect } from "react";
import WarehouseSelect from "../WarehouseSelect";
import WarehouseReceivingZoneSelect from "../WarehouseReceivingZoneSelect";
import WarehouseDockSelect, { warehouseDockValidator } from "../WarehouseDockSelect";

export const warehouseDeliveryValidator = (dependencyField) => ({ getFieldValue }) => ({
  validator: (_, value) => {
    const deliveryDate = getFieldValue(dependencyField);

    if (deliveryDate && !value) {
      return Promise.reject(new Error("Please select a receiving zone for the selected delivery date"));
    }

    return Promise.resolve();
  },
});

const WarehouseDetailSelection = ({ warehouseDetail, ...rest }) => {
  const selectedWarehouseId = Form.useWatch("warehouseID", rest.form);
  const selectedReceivingZoneId = Form.useWatch("warehouseReceivingZoneID", rest.form);
  const { data: receivingZones } = useWarehouseReceivingZone(selectedWarehouseId);

  useEffect(() => {
    if (selectedWarehouseId !== warehouseDetail?.warehouseID) {
      rest.form.setFieldsValue({
        warehouseReceivingZoneID: null,
        warehouseDockID: null,
      });
    }
  }, [selectedWarehouseId]);

  useEffect(() => {
    rest.form.setFieldsValue({
      warehouseID: warehouseDetail?.warehouseID,
      warehouseReceivingZoneID: warehouseDetail?.warehouseReceivingZoneID,
      warehouseDockID: warehouseDetail?.warehouseDockID,
    });
  }, [warehouseDetail]);

  return (
    <>
      <Form.Item name="warehouseID"
                 label="Warehouse"
                 rules={[{ required: true, message: "Please select a warehouse" }]}>
        <WarehouseSelect size="medium" />
      </Form.Item>
      <Form.Item name="warehouseReceivingZoneID"
                 label="Receiving Zone"
                 rules={[warehouseDeliveryValidator("deliveryTime")]}
                 dependencies={["deliveryTime"]}>
        <WarehouseReceivingZoneSelect
          size="medium"
          warehouseId={selectedWarehouseId}
        />
      </Form.Item>
      <Form.Item name="warehouseDockID"
                 rules={[warehouseDockValidator("warehouseReceivingZoneID", receivingZones)]}
                 dependencies={["warehouseReceivingZoneID"]}
                 label="Dock">
        <WarehouseDockSelect
          size="medium"
          warehouseId={selectedWarehouseId}
          receivingZoneId={selectedReceivingZoneId}
        />
      </Form.Item>
    </>
  );
};

export default WarehouseDetailSelection;